import useApi from '../../common/hooks/useApi'
import useSWR from 'swr'
import useAccounts from '../../common/hooks/useAccounts'
import { type AccountResource } from '@amici/myamici-api-client/models/account-resource'

interface UseAccountsApiHook {
  admins: AccountResource[] | undefined
  isLoading: boolean
  hasData: boolean
  loadingError: any
}

function useAdminUsersApi (): UseAccountsApiHook {
  const { accountsApi, fetcherWithoutParams } = useApi()
  const { activeAccount } = useAccounts()

  const {
    data,
    isLoading,
    error: loadingError
  } = useSWR(
    'allAdmins',
    async () =>
      await fetcherWithoutParams(
        accountsApi.getOrderManagers({
          accountId: activeAccount?.accountId ?? ''
        })
      )
  )

  const hasData = Array.isArray(data) && data.length > 0

  return {
    admins: data?.content ?? [],
    isLoading,
    hasData,
    loadingError
  }
}

export default useAdminUsersApi
